export const apiUrl = process.env.VUE_APP_API_URL;
export const appName = process.env.VUE_APP_NAME;
